import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { setOpenPopup } from '#action/project/devices-popup';
import DevicePopup from '#component/device/devices-popup/device-popup-project';
import DeviceSearch from '#component/general/form-device-field/search/device-search';
import { DeviceChip } from '#component/general/form-device-field/device-chip';
import {
  ButtonsContainer,
  DeviceFieldCnt,
  DevicesChipsCtn,
  StyledAddBtn,
  StyledModifyBtn,
  TitleDiv
} from './styles';

const DeviceField = ({
  disabled,
  project,
  openedFromCreateForm,
  formData,
  initialDevices,
  handleDeviceSetData
}) => {
  const dispatch = useDispatch();
  const meta = useSelector(s => s.meta, shallowEqual);
  const isDevicePopupOpen = useSelector(s => s.projectDevicesPopup?.isOpen, shallowEqual);
  const showModifyButton = formData?.length > 10;
  const title = formData?.length ? `Devices (${formData.length})` : 'Devices';

  const handleOpenDevicePopup = (e, addMode) => {
    dispatch(setOpenPopup(true, false, addMode));
  };

  const handleRemoveDevice = device => {
    const newDevices = formData.filter(d => d.id !== device.id);
    handleDeviceSetData(newDevices);
  };

  return (
    <>
      <DeviceFieldCnt>
        <div>
          <TitleDiv disabled={disabled}>{title}</TitleDiv>
          <DevicesChipsCtn>
            {formData?.length <= 10 && formData.map(device => (
              <DeviceChip
                device={device}
                meta={meta}
                handleRemoveDevice={handleRemoveDevice}
                disabled={disabled}
              />
            ))}
          </DevicesChipsCtn>
        </div>
        <ButtonsContainer>
          <StyledAddBtn
            size="small"
            color="secondary"
            aria-label="Add devices"
            disabled={disabled}
            onClick={e => handleOpenDevicePopup(e, true)}
          >
            <AddIcon />
            <span>Add devices</span>
          </StyledAddBtn>
          {showModifyButton ?
            <StyledModifyBtn
              size="small"
              color="secondary"
              aria-label="Modify devices"
              onClick={handleOpenDevicePopup}
            >
              <span>{`Modify devices (${formData.length})`}</span>
            </StyledModifyBtn> :
            <DeviceSearch
              handleDeviceSetData={handleDeviceSetData}
              formData={formData}
              disabled={disabled}
              projectId={project?.id}
            />}
        </ButtonsContainer>
      </DeviceFieldCnt>
      {(isDevicePopupOpen) &&
        <DevicePopup
          disabled={disabled}
          project={project}
          open={isDevicePopupOpen}
          openedFromCreateForm={openedFromCreateForm}
          formData={formData}
          setFormDevices={handleDeviceSetData}
          initialFormDevices={initialDevices}
          emptyForm={!formData?.length}
        />}
    </>
  );
};

export default DeviceField;
